export default function() {
    return {
        apiUrl: process.env.VUE_APP_API_URL,
        baseUrl: process.env.VUE_APP_BASE_URL,
        agencyId: this.$store.state.user?.agency?.id,

        // Show messages
        messageCustomerDocument: null,
        messageCustomerForm: null,
        messageTypeCustomerForm: null,

        // Messages
        documentInvalid: 'CPF informado não é válido.',
        customerExists: 'Cliente já cadastrado, disponivel apenas vinculo com a trip.',
        customerNotExist: 'Não existe nenhum cliente com esse CPF, disponivel para cadastro.',
        registeredCustomer: 'Cadastro realizado com sucesso! Em breve o cliente irá receber um email para completar o cadastro!',
        updatedClient: 'Cliente adicionado na trip com sucesso!',
        invalidData: 'Verifique os campos e tente novamente.',
        serverError: 'Ocorreu um erro, por favor tente novamente mais tarde.',

        // Document
        documentConsultation: null,

        // Is pre register
        isPreRegistration: false,

        trip: null,
        blockForm: true,
        success: false,
        codeError: null,
        blockField: {
            name: true,
            email: true,
            phone: true,
        },
        customer: {
            cpf: '',
            rg: '',
            email: '',
            name: '',
            phone: '',
            place: '',
            accommodations: [],
            optionals: []
        },
        error: {
            cpf: null,
            name: null,
            email: null,
            place: null,
            accommodations: null,
            optionals: null
        },
    }
}
